import { useNftx } from '@nftx/react';
import { Address } from 'nftx.js';
import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../queryKeys';

const useAsset = (
  {
    assetAddress,
    tokenId,
  }: {
    assetAddress?: Address;
    tokenId?: `${number}`;
  },
  opts?: any
) => {
  const {
    network,
    core: { fetchAsset },
  } = useNftx();
  const enabled = !!(assetAddress && tokenId && opts?.enabled !== false);

  return useQuery(
    [QueryKey.ASSET, network, assetAddress, tokenId],
    () => {
      if (enabled) {
        return fetchAsset({ network, assetAddress, tokenId });
      }
    },
    { staleTime: Infinity, refetchInterval: Infinity, ...opts, enabled }
  );
};

export default useAsset;
